/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/**
 * @author Shalini
 * @name BulkUploadHistory
 * @desc File Upload history component
 */
import React from 'react';
import clsx from 'clsx';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import styles from './BulkUpload.module.css';
import TableIcons from '../TableIcons';
import ModalDialog from '../ModalDialog';
import ErrorListComponent from './ErrorListComponent';
import { getUploadedPercent } from './OngoingUploads';
import { CustomToolTip } from '../ToolTips';
import Loader from '../Loader'; // import { ProcessingStatusTooltip, ErrorLabelTooltip, UpstreamSystemTooltip } from './constants';

import { loadLangCommon } from '../LocalizeLang';
import enData from './lang/en.json';
import esData from './lang/es.json';
import cmnData from './lang/cmn.json';
import Message from '../Message';
import { MaterialUiTable, MaterialUiIcons, MaterialUiCore } from '@gscope-mfe/common-libs';
import { Services, AppUtils } from '@gscope-mfe/app-bridge';
import frData from './lang/fr.json';
import { getNextCacheRefreshTime, downloadErrorWithOriginalRow, isExcelWorkbook } from './utils';
import Left_Arrow from './svg/Left_Arrow.svg';

const MaterialTable = MaterialUiTable.default,
    CancelRoundedIcon = MaterialUiIcons.CancelRounded,
    CheckCircleIcon = MaterialUiIcons.CheckCircle,
    TimerIcon = MaterialUiIcons.Timer,
    TimerOutlinedIcon = MaterialUiIcons.TimerOutlined,
    { CircularProgress } = MaterialUiCore,
    RefreshRoundedIcon = MaterialUiIcons.RefreshRounded,
    { TablePagination, Tooltip } = MaterialUiCore,
    { bulkUploadHistory, getDownStreamMapping, downloadOriginalFile, downloadSuccessReport } = Services;
export const renderTitleWithTooltip = (title, tooltipData) => (
    <CustomToolTip title={tooltipData} placement={'top'}>
        <span>{title}</span>
    </CustomToolTip>
);
/**
 * @name renderUploadStatus
 * @desc Renders the upload status
 * @param {String} status
 * @param {Object} summary
 */
export const renderUploadStatus = (status, summary, trans) => {
    if (status === 'F')
        return (
            <CustomToolTip title={trans('bulkUpload.constProcessingStatusTooltip')}>
                <>
                    <CancelRoundedIcon fontSize="small" style={{ fill: 'var(--alertRed)', fontSize: '15px' }} />
                    <span className="statusLabel  statusLabel-sm">{trans('bulkUpload.uploadFailed')}</span>
                </>
            </CustomToolTip>
        );
    if (status === 'Q')
        return (
            <span className={styles.bulkUpload_chip_queue}>
                <TimerOutlinedIcon fontSize={'small'} style={{ fontSize: '15px' }} />
                {trans('bulkUpload.queuing')}
            </span>
        );
    if (status === 'P') {
        const percent = summary.total !== 0 ? Math.round((summary.processed / summary.total) * 100) : 0;
        return (
            <CustomToolTip title={trans('bulkUpload.processingInPercent', { percent: percent })}>
                <>
                    <TimerIcon fontSize="small" style={{ fontSize: '15px' }} />
                    <span className="statusLabel statusLabel-sm">
                        {trans('bulkUpload.processingInPercent', { percent: percent })}
                    </span>
                </>
            </CustomToolTip>
        );
    }
    if (status === 'S') {
        if (summary.total === 0) {
            return (
                <CustomToolTip title={trans('bulkUpload.constProcessingStatusTooltip')}>
                    <>
                        <CancelRoundedIcon fontSize="small" style={{ fill: 'var(--alertRed)', fontSize: '15px' }} />

                        <span className="statusLabel statusLabel-sm">{trans('bulkUpload.recordsNotFound')}</span>
                    </>
                </CustomToolTip>
            );
        }
        return (
            <CustomToolTip title={trans('bulkUpload.constProcessingStatusTooltip')}>
                <>
                    <CheckCircleIcon fontSize="small" style={{ fill: '#1DA578', fontSize: '15px' }} />
                    {trans('bulkUpload.uploaded')}
                </>
            </CustomToolTip>
        );
    }
};
export const downloadFile = async (transactionId, fileName, setIsDownload) => {
    const resFile = await downloadOriginalFile(transactionId);
    const url = window.URL.createObjectURL(new Blob([resFile.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    setIsDownload(null);
};

export const downloadSuccessFile = async (transactionId) => {
    const SUCCESS_DATA_FILE_NAME = 'Success_data.csv';
    const resSuccessFile = await downloadSuccessReport(transactionId);
    const url = window.URL.createObjectURL(new Blob([resSuccessFile.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', SUCCESS_DATA_FILE_NAME);
    link.download = SUCCESS_DATA_FILE_NAME;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

const BulkUploadHistory = (props) => {
    const history = useHistory();
    const [uploadHistory, setUploadHistory] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isDownload, setIsDownload] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState({});
    const [downstreamData, setDownstreamData] = React.useState({});
    const [isSelected, setIsSelected] = React.useState('');

    const handleClose = () => setOpen(false);

    const trans = loadLangCommon(
        [
            ['en', enData],
            ['es', esData],
            ['fr', frData],
            ['cmn', cmnData],
        ],
        'bulkUpload',
    );
    let showTIDcolumn = false;
    let bulkUpdateHistory = false;
    if (props.location && props.location.state) {
        showTIDcolumn = props.location.state.showTIDcolumn;
        bulkUpdateHistory = props.location.state.bulkUpdateHistory;
    }
    const { userInfo, setBreadCrumbArr, headerConfig, setHeaderConfig, queryParam = {} } = AppUtils.get();
    let columns = [
        {
            field: 'transactionId',
            title: '',
            render: () => null,
            headerStyle: {
                display: 'none',
            },
            cellStyle: {
                display: 'none',
            },
            searchable: true,
        },
        {
            field: 'fileName',
            title: trans('bulkUpload.fileName'),
            searchable: false,
            cellStyle: { maxWidth: '260px' },
        },
        {
            field: 'fileNameSearch',
            title: '',
            render: () => null,
            searchable: true,
        },
        {
            field: 'service',
            title: renderTitleWithTooltip(
                trans('bulkUpload.upstreamSystem'),
                trans('bulkUpload.constUpstreamSystemTooltip'),
            ),
            searchable: true,
        },
        {
            field: 'error',
            title: renderTitleWithTooltip(trans('bulkUpload.Error'), trans('bulkUpload.constErrorLabelTooltip')),
        },
        { field: 'download', title: trans('bulkUpload.actions') },
        {
            field: 'success',
            title: trans('bulkUpload.Success'),
            searchable: false,
        },
        {
            field: 'cacheRefreshTime',
            title: (
                <>
                    <>{trans('bulkUpload.nextRefresh')}</>
                    <Tooltip title={trans('bulkUpload.nextRefreshInfo')} placement="top" arrow>
                        <i className={`sct-icon icon-Info-18 ${styles.refreshTimeInfoIcon}`}></i>
                    </Tooltip>
                </>
            ),
            searchable: false,
        },
    ];

    if (showTIDcolumn) {
        columns = [
            {
                field: 'transactionId',
                title: trans('bulkUpload.transactionId'),
                searchable: true,
            },
            {
                field: 'fileName',
                title: trans('bulkUpload.fileName'),
                searchable: false,
            },
            {
                field: 'fileNameSearch',
                title: '',
                render: () => null,
                searchable: true,
            },
            {
                field: 'uploadDate',
                title: trans('bulkUpload.uploadDateTime'),
                searchable: true,
            },
            {
                field: 'service',
                title: renderTitleWithTooltip(
                    trans('bulkUpload.upstreamSystem'),
                    trans('bulkUpload.constUpstreamSystemTooltip'),
                ),
                searchable: true,
            },
            {
                field: 'status',
                title: renderTitleWithTooltip(
                    trans('bulkUpload.processingStatus'),
                    trans('bulkUpload.constProcessingStatusTooltip'),
                ),
                searchable: true,
            },
            {
                field: 'error',
                title: renderTitleWithTooltip(trans('bulkUpload.Error'), trans('bulkUpload.constErrorLabelTooltip')),
            },
        ];
    }

    if (bulkUpdateHistory) {
        columns.push({ field: 'uploadDesc', title: trans('bulkUpload.comments'), searchable: true });
    }

    const searchableCols = columns.filter((c) => c.searchable).map((c) => c.field); // Only single column will be searcheable from url due to material-table limitations

    const [searchText, setSearchText] = React.useState(
        searchableCols.filter((c) => c in queryParam).reduce((acc, c) => acc || queryParam[c], ''),
    );
    /**
     * @name updateDownstreamMapping
     * @desc Fetched the list of downstream and maps it to the current data
     */

    const updateDownstreamMapping = async () => {
        setIsLoading(true);
        const { data } = await getDownStreamMapping();
        setDownstreamData(data);
        setIsLoading(false);
    };
    /**
     * @name fetchHistoryList
     * @desc Fetches the list of history for a user
     */

    const fetchHistoryList = async () => {
        setIsLoading(true);
        const { data } = await bulkUploadHistory(userInfo.loggedInUserName, bulkUpdateHistory);
        setIsLoading(false);

        if (data.payload) {
            setUploadHistory(data.payload.history.filter((item) => item.fileName));
        }
    };
    /**
     * @name showErrorModal
     * @desc Show the error modal
     * @param {String} fileName
     * @param {String} transactionId
     */

    const showErrorModal = async (fileName, transactionId, status, service) => {
        if (isExcelWorkbook(fileName)) {
            await downloadErrorWithOriginalRow(transactionId, 'Error_' + fileName);
        } else {
            setSelectedFile({ ...selectedFile, fileName, transactionId, status, service });
            setOpen(true);
        }
    };
    /**
     * @name createData
     * @desc Creates Data for table
     */
    const createData = ({
        uploadDate,
        fileName,
        service,
        status,
        summary,
        transactionId,
        blobReferenceName,
        uploadDesc,
        success,
        cacheBuildCount,
        cacheTimestamp,
        isWasm,
    }) => ({
        transactionId,
        uploadDate: `${moment(uploadDate)?.tz(moment.tz.guess()).format('MMM-DD-YYYY [at] hh:mm:ss a z')}`,
        fileName: (
            <span className={styles.recentUploads_fileMetaData}>
                <span className={styles.recentUploads_fileName}>{fileName}</span>
                <p className={styles.recentUploads_timeStamp}>
                    {renderUploadStatus(status, summary, trans)} |
                    <span className={styles.recentUploads_Datetime}>
                        {`${moment(uploadDate).tz(moment.tz.guess()).format('MMM-DD-YYYY [at] hh:mm:ss a z')}`}
                    </span>
                </p>
            </span>
        ),
        fileNameSearch: fileName,
        service: service ? downstreamData[service] || service.toUpperCase() : service,
        status: renderUploadStatus(status, summary, trans),
        error:
            summary.errors === 0 ? (
                '--'
            ) : (
                <CustomToolTip title={trans('bulkUpload.constErrorLabelTooltip')}>
                    <span
                        className={styles.bulkUpload_chip_error}
                        onClick={
                            /* istanbul ignore next */
                            () => showErrorModal(fileName, transactionId, status, service)
                        }
                    >
                        {!isExcelWorkbook(fileName) ? summary.errors : ''} {trans('bulkUpload.errors')}
                    </span>
                </CustomToolTip>
            ),
        uploadDesc,
        success:
            status === 'S' ? (
                summary.processed === summary.total ? (
                    <span
                        className={isWasm ? ' ' : styles.history_errorLabel}
                        onClick={() => (!isWasm ? downloadSuccessFile(transactionId) : {})}
                    >
                        {isWasm ? '--' : summary.processed - summary.errors + ' ' + trans('bulkUpload.Success')}
                    </span>
                ) : (
                    '--'
                )
            ) : (
                '--'
            ),
        download: (
            <CustomToolTip title={trans('bulkUpload.constFileReceiptTooltip')}>
                {isDownload === transactionId ? (
                    <CircularProgress color="secondary" size="1.3rem" />
                ) : (
                    <span
                        id={transactionId}
                        className={clsx('sct-icon icon-Download-18 ', styles.bulkUpload_download)}
                        onClick={
                            /* istanbul ignore next */
                            (e) => {
                                if (e.target.id == transactionId) setIsDownload(transactionId);
                                downloadFile(transactionId, fileName, setIsDownload);
                            }
                        }
                    ></span>
                )}
            </CustomToolTip>
        ),
        cacheRefreshTime: (() => {
            if (status === 'P' || status === 'Q' || (status === 'S' && summary.processed < summary.total)) {
                const timestamp = getNextCacheRefreshTime(cacheBuildCount, cacheTimestamp);
                return timestamp ? moment(timestamp).format('MMM Do YYYY HH:mm') : '--';
            } else return '--';
        })(),
    });

    const rows = uploadHistory.map((file) => createData(file));
    React.useEffect(() => {
        updateDownstreamMapping();
        fetchHistoryList();
        setBreadCrumbArr([]);
        setHeaderConfig({
            ...headerConfig,
            title: null,
            appBackGround: '#fff',
            children: (
                <div className={styles.history_backBtnContainer}>
                    <img onClick={() => history.goBack()} src={Left_Arrow} alt="back" />
                    <strong>
                        {bulkUpdateHistory
                            ? trans('bulkUpdate.historyOfUpdates')
                            : trans('bulkUpload.historyOfUploads')}
                    </strong>
                </div>
            ),
        });
    }, []);
    return (
        <div className={styles.history_tableContainer}>
            <Loader show={isLoading} />
            <div className={styles.history_warningMsg_container}>
                <Message
                    variant="warning"
                    className={styles.border}
                    style="outlined"
                    message={trans('bulkUpload.refreshNoteMsg')}
                />
                <Message
                    variant="warning"
                    className={styles.border}
                    style="outlined"
                    message={trans('bulkUpload.ThirtyDaysMsg')}
                />
            </div>
            <MaterialTable
                columns={columns}
                data={rows}
                title={
                    <>
                        <strong className={styles.history_table_title}>
                            {trans('bulkUpload.details')} {uploadHistory?.length} {trans('bulkUpload.results')}
                        </strong>
                        <CustomToolTip title={trans('bulkUpload.refreshProcessingStatus')}>
                            <RefreshRoundedIcon fontSize="small" onClick={() => fetchHistoryList()} />
                        </CustomToolTip>
                    </>
                }
                icons={TableIcons}
                onSearchChange={setSearchText}
                options={{
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 30, 40, 50, 100],
                    showEmptyDataSourceMessage: false,
                    emptyRowsWhenPaging: false,
                    thirdSortClick: false,
                    headerStyle: {
                        backgroundColor: 'var(--backgroundGray)',
                        color: 'var(--black)',
                        marginLeft: '0px',
                    },
                    searchText,
                    searchFieldStyle: {
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '4px 8px',
                    },
                }}
                localization={{
                    toolbar: {
                        searchPlaceholder: `${trans('bulkupload.search')}`,
                    },
                }}
                components={{
                    Pagination: (props) => {
                        const newProps = {
                            ...props,
                            labelRowsPerPage: trans('bulkUpload.itemsPerPage'),
                            SelectProps: {
                                inputProps: {
                                    'aria-label': trans('bulkUpload.itemsPerPage'),
                                },
                            },
                        };
                        return (
                            <TablePagination
                                style={newProps.style}
                                rowsPerPageOptions={newProps.rowsPerPageOptions}
                                rowsPerPage={+newProps.rowsPerPage}
                                colSpan={newProps.colSpan}
                                count={newProps.count}
                                page={+newProps.page}
                                SelectProps={newProps.SelectProps}
                                onChangePage={newProps.onChangePage}
                                icons={newProps.icons}
                                onChangeRowsPerPage={newProps.onChangeRowsPerPage}
                                labelRowsPerPage={newProps.labelRowsPerPage}
                                labelDisplayedRows={({ from, to, count }) => {
                                    return '' + from + '-' + to + ` ${trans('bulkUpload.of')} ` + count;
                                }}
                            />
                        );
                    },
                }}
            />
            <ModalDialog
                title={
                    <div>
                        {trans('bulkUpload.errorReport')} {selectedFile.fileName}
                    </div>
                }
                open={open}
                handleClose={handleClose}
            >
                <ErrorListComponent
                    bulkUpdateHistory={bulkUpdateHistory}
                    transactionId={selectedFile.transactionId}
                    status={selectedFile.status}
                    trans={trans}
                    fileName={selectedFile.fileName}
                    service={selectedFile.service}
                />
            </ModalDialog>
        </div>
    );
};

export default BulkUploadHistory;
